module.exports = __webpack_public_path__ + "static/build-622565f686bfca5cc45d44419185745d.gif";